import { styled } from "@mui/material/styles";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import { CheckOutlined } from "@mui/icons-material";
import { FooterText } from "../../../components/Common/FooterText";

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const BenefitsGrid = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StyledImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "auto",
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  borderRadius: theme.spacing(2),
}));

export const BodyTypography = styled(Typography)(({ theme }) => ({
  ...theme.body,
  lineHeight: "20px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const BodyTypographyTight = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const BodyTypographySpaced = styled(FooterText)(({ theme }) => ({
  margin: 0,
}));

export const BenefitRow = styled(Stack)({
  flexDirection: "row",
});

export const BenefitIcon = styled(CheckOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
  flexShrink: 0,
}));

export const BenefitText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
